import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getReimburse } from "../../../../store/actions";
import CustomRouterLink from "../../../../components/CustomRouterLink/CustomRouterLink";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  CircularProgress,
  Button,
  IconButton,
  Tooltip,
  Box,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { moneyFormat, capitalize } from "../../../../shared/utility";
import { Pagination } from "@material-ui/lab";
import { useHistory } from "react-router-dom";

import { TableHead, Dialog, AlertDialog } from "./component";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  pagination: {
    padding: theme.spacing(0.5),
    "& .MuiPagination-ul": {
      justifyContent: "center",
    },
  },
}));

const EnhancedTable = ({ reimburse, getReimburse }) => {
  const classes = useStyles();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dialog, setDialog] = useState({
    open: false,
    path: null,
  });
  const [dialogAlert, setDialogAlert] = useState({
    open: false,
    id: null,
  });

  const handlePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpenDialog = (path) => {
    setDialog({
      open: true,
      path: path,
    });
  };

  const handleOpenDialogAlert = (id) => {
    setDialogAlert({
      open: true,
      id: id,
    });
  };

  useEffect(() => {
    getReimburse(page, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <TableHead />
            <TableBody>
              {reimburse.loadingData ? (
                <TableRow>
                  <TableCell align="center" colSpan={8}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : reimburse.data.length > 0 ? (
                reimburse.data.map((row, index) => {
                  return (
                    <TableRow tabIndex={-1} key={index}>
                      <TableCell>
                        {index + 1 + (page - 1) * rowsPerPage}
                      </TableCell>
                      <TableCell>{row.reimburse_date}</TableCell>
                      <TableCell>{row.created_at}</TableCell>
                      <TableCell>{row.description}</TableCell>
                      <TableCell>Rp. {moneyFormat(row.total)}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => {
                            handleOpenDialog(row.path);
                          }}
                        >
                          Lihat Kwitansi
                        </Button>
                      </TableCell>
                      <TableCell>{capitalize(row.status)}</TableCell>
                      <TableCell>{row.action_by}</TableCell>
                      <TableCell>
                        <Box display="flex">
                          {row.status === "disetujui" ||
                          row.status === "ditolak" ? (
                            <IconButton
                              aria-label="edit"
                              color="primary"
                              disabled
                            >
                              <Tooltip title="Edit">
                                <EditIcon />
                              </Tooltip>
                            </IconButton>
                          ) : (
                            <IconButton
                              onClick={() =>
                                history.push(`/form-reimburse/${row.id}`)
                              }
                              aria-label="edit"
                              color="primary"
                            >
                              <Tooltip title="Edit">
                                <EditIcon />
                              </Tooltip>
                            </IconButton>
                          )}
                          {row.status === "waiting" ||
                          row.status === "ditolak" ? (
                            <IconButton
                              aria-label="delete"
                              onClick={() => {
                                handleOpenDialogAlert(row.id);
                              }}
                            >
                              <Tooltip title="Hapus">
                                <DeleteIcon />
                              </Tooltip>
                            </IconButton>
                          ) : (
                            <IconButton aria-label="delete" disabled>
                              <Tooltip title="Hapus">
                                <DeleteIcon />
                              </Tooltip>
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={8}>
                    Data Kosong
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.pagination}
        >
          <Grid item xs={8}>
            <Pagination
              className={classes.pagination}
              count={reimburse.last_page}
              page={page}
              onChange={handlePage}
              color="primary"
            />
          </Grid>
        </Grid>
      </Paper>
      <Dialog
        dialog={dialog}
        onClose={() => {
          setDialog({
            open: false,
            path: null,
          });
        }}
      />
      <AlertDialog
        dialogAlert={dialogAlert}
        onClose={() => {
          setDialogAlert({
            open: false,
            id: null,
          });
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    reimburse: state.reimburse,
  };
};

export default connect(mapStateToProps, { getReimburse })(EnhancedTable);
